/*
    © 2023 EcomGraduates.com
    https://www.ecomgraduates.com
*/
window.onSubmitAtcFormGiftBox = async (form) => {
    console.log('onSubmitAtcFormGiftBox');
    const giftBoxToggle = document.querySelector('#gift-box-toggle .cyg-toggle');
    const giftBandToggle = document.querySelector('#gift-band-toggle .cyg-toggle');
    const giftBandSelect = document.querySelector('#product-option-gift-band'); // Replace with the correct ID of your select element

    // Find the quantity input inside the form
    const quantityInput = form.querySelector('input[name="quantity"]');
    const quantity = quantityInput ? parseInt(quantityInput.value, 10) || 1 : 1;

    // Generate a unique identifier for the bundle
    const uuid = crypto.randomUUID();

    // Initialize an array for cart items
    const items = [];

    // Capture the selected gift box name dynamically
    const selectedGiftBoxName = giftBandSelect?.options[giftBandSelect.selectedIndex]?.text || "Default Gift Box Name";

    // Get the parent product title from the data-parent-product attribute
    const parentProductTitle = giftBandSelect?.dataset?.parentProduct || '';

    // Prepare properties for the gift box
    const giftBoxProperties = {};

    // Add gift band-related properties to the gift box only if both are toggled
    if (giftBoxToggle && giftBoxToggle.checked && giftBandToggle && giftBandToggle.checked) {
        giftBoxProperties._bundleId = uuid; // Unique identifier for the parent item
        giftBoxProperties._GiftBandMessage = selectedGiftBoxName; // Add selected gift band name to the gift box
    } else if (giftBandToggle && giftBandToggle.checked) {
        // If only the gift band is selected, add the gift band name
        giftBoxProperties._GiftBandMessage = selectedGiftBoxName;
    }

    // Add the gift box item if toggled
    if (giftBoxToggle && giftBoxToggle.checked) {
        items.push({
            id: Number(giftBoxToggle.value), // Gift box variant ID
            quantity: quantity,
            properties: giftBoxProperties
        });
    }

    // Add the gift band item if toggled
    if (giftBandToggle && giftBandToggle.checked) {
        const selectedGiftBandOption = giftBandSelect.options[giftBandSelect.selectedIndex];
        const giftBandVariantId = selectedGiftBandOption?.value; // Ensure it's a valid option

        if (giftBandVariantId) {
            const giftBandProperties = {
                Box: parentProductTitle // Use the parent product title from the data attribute
            };

            // Add bundle ID to gift band properties if both are toggled
            if (giftBoxToggle && giftBoxToggle.checked) {
                giftBandProperties._bundleParentId = uuid; // Links back to the parent item's _bundleId
            }

            items.push({
                id: Number(giftBandVariantId), // Gift band variant ID
                quantity: quantity,
                properties: giftBandProperties
            });
        }
    }

    // Get and update the button state
    const btn = form.querySelector('.btn-atc');
    const savedBtnInnerHtml = btn.innerHTML;

    btn.innerHTML = `
        <div class="spinner-border spinner-border-sm" role="status">
            <span class="visually-hidden">Loading...</span>
        </div>
    `;
    form.classList.add('loading');

    console.log(items);
    // Submit the items array to the cart
    const response = await fetch('/cart/add.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ items })
    });

    // Reset the button state
    form.classList.remove('loading');
    btn.innerHTML = savedBtnInnerHtml;

    // Update cart and UI
    window.refreshCartContents(response);

    // Show cart drawer if it exists
    if (document.querySelector('#offcanvas-cart')) {
        bootstrap.Offcanvas.getOrCreateInstance('#offcanvas-cart').show();
    }

    // Close any quick view modals
    document.querySelectorAll('.quick-view-modal').forEach(modalElement => {
        const modalInstance = bootstrap.Modal.getInstance(modalElement);
        if (modalInstance) {
            modalInstance.hide();
        }
    });
};

// Modified onSubmitAtcForm function to use checkForExtras
window.onSubmitAtcForm = async (form, event) => {
    event.preventDefault()

    const giftBoxToggle = document.querySelector('#gift-box-toggle .cyg-toggle');
    if (giftBoxToggle && giftBoxToggle.checked) {
        return onSubmitAtcFormGiftBox(form,);
    }
    let formData = new FormData(form);

    const btn = form.querySelector('.btn-atc')
    const savedBtnInnerHtml = btn.innerHTML

    btn.innerHTML = `
        <div class="spinner-border spinner-border-sm" role="status">
            <span class="visually-hidden">Loading...</span>
        </div>
    `
    form.classList.add('loading')

    const response = await fetch('/cart/add.js', { 
        method: 'POST', 
        body: formData 
    })

    form.classList.remove('loading')
    btn.innerHTML = savedBtnInnerHtml

    window.refreshCartContents(response)

    if (document.querySelector('#offcanvas-cart')) {
        bootstrap.Offcanvas.getOrCreateInstance('#offcanvas-cart').show()
    }

    document.querySelectorAll('.quick-view-modal').forEach(modalElement => {
        const modalInstance = bootstrap.Modal.getInstance(modalElement)
        if (modalInstance) {
            modalInstance.hide()
        }
    })
}


// function checkForExtras(formData) {
//     const giftBoxToggle = document.querySelector('#gift-box-toggle .cyg-toggle');
//     const giftBandToggle = document.querySelector('#gift-band-toggle .cyg-toggle');
//     const greetingSelect = document.querySelector('#greeting-select');

//     let itemIndex = 1; // Assuming the main product is at index 0

//     if (giftBoxToggle && giftBoxToggle.checked) {
//         formData.append(`items[${itemIndex}][id]`, giftBoxToggle.value);
//         formData.append(`items[${itemIndex}][quantity]`, '1');
//         formData.append(`items[${itemIndex}][properties][Gift Box]`, 'Yes');
//         itemIndex++;
//     }

//     if (giftBandToggle && giftBandToggle.checked) {
//         formData.append(`items[${itemIndex}][id]`, giftBandToggle.value);
//         formData.append(`items[${itemIndex}][quantity]`, '1');
//         formData.append(`items[${itemIndex}][properties][Gift Band]`, 'Yes');
//         formData.append(`items[${itemIndex}][properties][Greeting]`, greetingSelect.options[greetingSelect.selectedIndex].text);
//         itemIndex++;
//     }

//     return formData;
// }

/*
    'Add to cart' form based on variant
*/
window.onClickAtcFormVariant = async (btn, event) => {
    const form = btn.closest('form')
    form.querySelector('[name="id"]').value = btn.dataset.variantId

    window.onSubmitAtcForm(form, event)
}

/*
    Product options selector - Listen for change events
*/
let currentPriceFetch = null;

window.onChangeProductOption = async (input) => {
    const selectedOptions = []

    input.closest('form').querySelectorAll('.product-option').forEach(elem => {
        if (elem.type === 'radio') {
            if (elem.checked) {
                selectedOptions.push(elem.value)
            }
        } else {
            selectedOptions.push(elem.value)
        }
    })

    const selectedVariant = window.productVariants.find(variant =>
        JSON.stringify(variant.options) === JSON.stringify(selectedOptions)
    )

    const btn = input.closest('form').querySelector('.btn-atc')

    if (selectedVariant) {
        input.closest('form').querySelector('[name="id"]').value = selectedVariant.id

        if (selectedVariant.available) {
            btn.disabled = false
            btn.innerHTML = window.theme.product.addToCart
        } else {
            btn.disabled = true
            btn.innerHTML = window.theme.product.soldOut
        }

        // Cancel any pending price fetch
        if (currentPriceFetch && currentPriceFetch.abort) {
            currentPriceFetch.abort();
        }

        // Create new AbortController for this fetch
        const controller = new AbortController();
        currentPriceFetch = controller;

        // Add loading spinner
        const priceElement = input.closest('.product-content').querySelector('.product-price');
        priceElement.style.position = 'relative';
        priceElement.insertAdjacentHTML('beforeend', `
                <svg style="
    width: 24px; 
    height: 24px;
    animation: spin 1s linear infinite;
">
<style>
    @keyframes spin {
        from { transform: rotate(0deg); }
        to { transform: rotate(360deg); }
    }
</style> xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24">
                    <circle class="opacity-25" cx="12" cy="12" r="10" stroke="currentColor" stroke-width="4"></circle>
                    <path class="opacity-75" fill="currentColor" d="M4 12a8 8 0 018-8V0C5.373 0 0 5.373 0 12h4zm2 5.291A7.962 7.962 0 014 12H0c0 3.042 1.135 5.824 3 7.938l3-2.647z"></path>
                </svg>
            </div>
        `);

        try {
            const url = new URL(window.location);
            url.searchParams.set('variant', selectedVariant.id);
            
            const response = await fetch(url.toString(), {
                signal: controller.signal
            });
            
            const text = await response.text();
            const newDocument = new DOMParser().parseFromString(text, 'text/html');
            
            const priceElement = input.closest('.product-content').querySelector('.product-price');
            
            // Remove any existing spinner if it exists
            const existingSpinner = priceElement.querySelector('.price-loading-spinner');
            if (existingSpinner) {
                existingSpinner.remove();
            }
            
            const newProductPrice = newDocument.querySelector('.product-price');
            
            if (newProductPrice && priceElement) {
                priceElement.replaceWith(newProductPrice.cloneNode(true));
            }
        } catch (error) {
            if (error.name !== 'AbortError') {
                console.error('Error fetching updated price:', error);
            }
        }

        const purchaseOptionsWrapper = document.querySelector('#product-purchase-options')

        if (purchaseOptionsWrapper) {
            purchaseOptionsWrapper.querySelector('input#purchase-options-one-time + label [data-price]').textContent = Shopify.formatMoney(selectedVariant.price)
            purchaseOptionsWrapper.querySelector('input#purchase-options-subscription + label [data-price]').textContent = Shopify.formatMoney(selectedVariant.selling_plan_allocations[0].price)
        }

        const skuWrapper = input.closest('.product-content').querySelector('.current-variant-sku')

        if (skuWrapper) {
            if (selectedVariant.sku.length) {
                skuWrapper.textContent = selectedVariant.sku
                skuWrapper.removeAttribute('hidden')
            } else {
                skuWrapper.setAttribute('hidden', 'hidden')
            }
        }

        if (input.closest('#product-template')) {
            const url = new URL(window.location)
            url.searchParams.set('variant', selectedVariant.id)
            window.history.replaceState({}, '', url)
        }

        const customEvent = new CustomEvent('variantChange.ecomify.product', {
            detail: selectedVariant
        })
        window.dispatchEvent(customEvent)
    } else {
        btn.disabled = true
        btn.innerHTML = window.theme.product.unavailable
    }

    if (input.closest('.color-swatches')) {
        input.closest('.product-option-wrapper').querySelector('.color-swatches-title span')
            .textContent = input.value
    }

    if (input.closest('.size-buttons')) {
        input.closest('.product-option-wrapper').querySelector('.size-buttons-title span')
            .textContent = input.value
    }
}

/*
    Update various elements on variant change that need a new document fetch
*/
window.addEventListener('variantChange.ecomify.product', async (event) => {
    const inventoryBar = document.querySelector('#inventory-bar')

    if (inventoryBar) {
        inventoryBar.style.opacity = '.25'
    }

    const respoonse = await fetch(window.location.href)
    const text = await respoonse.text()
    const newDocument = new DOMParser().parseFromString(text, 'text/html')

    document.querySelector('#inventory-bar')
        ?.replaceWith(newDocument.querySelector('#inventory-bar'))
    document.querySelector('#product-qty-breaks')
        ?.replaceWith(newDocument.querySelector('#product-qty-breaks'))

    document.querySelector('#product-store-availability-wrapper')
        ?.replaceWith(newDocument.querySelector('#product-store-availability-wrapper'))

    initInventoryBar()
    initQtyBreaks()
})

/*
    Purchase options (selling/subscription plans)
*/
const initPurchaseOptions = () => {
    const wrapper = document.querySelector('#product-purchase-options')

    if (!wrapper) return

    wrapper.querySelectorAll('[name="purchase_option"]').forEach(input => {
        input.addEventListener('change', () => {
            if (input.id === 'purchase-options-one-time') {
                wrapper.querySelector('#purchase-delivery-options').setAttribute('hidden', 'hidden')
                wrapper.querySelector('[name="selling_plan"]').disabled = true
            } else {
                wrapper.querySelector('#purchase-delivery-options').removeAttribute('hidden')
                wrapper.querySelector('[name="selling_plan"]').disabled = false
            }
        })
    })
}
initPurchaseOptions()

// Product Item - Handle variant change
window.onChangeProductItemVariant = (select, event) => {
    if (select.options[select.selectedIndex].dataset.variantImage?.length) {
        select.closest('.product-item').querySelector('.product-item-img').src =
            select.options[select.selectedIndex].dataset.variantImage
    }

    const compareAtPrice = select.options[select.selectedIndex].dataset.compareAtPrice
    const price = select.options[select.selectedIndex].dataset.price

    if (compareAtPrice.length) {
        select.closest('.product-item').querySelector('.product-item-price').innerHTML = `
            <span class="product-item-price-compare text-muted me-1">
                    ${Shopify.formatMoney(compareAtPrice)}
            </span>
            <span class="product-item-price-final">
                ${Shopify.formatMoney(price)}
            </span>
        `
    } else {
        select.closest('.product-item').querySelector('.product-item-price').innerHTML = `
            <span class="product-item-price-final">
                ${Shopify.formatMoney(price)}
            </span>
        `
    }
}

/*
    'Buy it now' button
*/
window.onClickBuyBtn = (btn) => {
    btn.innerHTML = `
        <div class="spinner-border spinner-border-sm" role="status">
            <span class="visually-hidden">Loading...</span>
        </div>
    `
    const form = btn.closest('form')
    const variantId = form.querySelector('[name="id"]').value
    const qty = Number(form.querySelector('input[name="quantity"]')?.value || 1)
    window.location.href = `/cart/${variantId}:${qty}`
}

/*
    Product Gallery
*/
const initProductGallery = () => {
    document.querySelectorAll('.product-gallery:not(.init)').forEach(gallery => {
        gallery.classList.add('init')

        const main = new Splide(gallery.querySelector('.main-splide'), {
            start: Number(gallery.dataset.start),
            rewind: true,
            arrows: false,
            rewindByDrag: true,
            pagination: false,
            noDrag: 'model-viewer',
            mediaQuery: 'min',
            breakpoints: {
                0: { padding: 0, pagination: true },
                992: { padding: 0, pagination: false }
            }
        })

        const totalSlides = gallery.querySelectorAll('.main-splide .splide__slide').length

        const thumbs = new Splide(gallery.querySelector('.thumbs-splide'), {
            start: Number(gallery.dataset.start),
            gap: '.5rem',
            rewind: true,
            rewindByDrag: true,
            pagination: false,
            isNavigation: true,
            focus: totalSlides > 5 ? 'center' : 0,
            mediaQuery: 'min',
            breakpoints: {
                0: { perPage: 4, arrows: true },
                576: { perPage: 5, arrows: true },
                768: { perPage: 5, arrows: true },
                992: { perPage: 5, arrows: true },
                1200: { perPage: 5, arrows: true },
                1400: { perPage: 5, arrows: true }
            }
        })

        main.on('move', (newIndex, prevIndex) => {
            const iframe = gallery.querySelector(`.splide__slide:nth-child(${prevIndex + 1}) iframe`)
            const video = gallery.querySelector(`.splide__slide:nth-child(${prevIndex + 1}) video`)
            if (iframe) {
                // eslint-disable-next-line no-self-assign
                iframe.src = iframe.src
            }
            if (video) {
                video.pause()
            }
        })

        window.addEventListener('variantChange.ecomify.product', (event) => {
            const selectedVariant = event.detail

            if (selectedVariant.featured_media) {
                main.go(selectedVariant.featured_media.position - 1)
            }
        }, false)

        main.sync(thumbs)
        main.mount()
        thumbs.mount()

        if (window.matchMedia('(min-width: 992px)').matches) {
            const navbarHeight = document.querySelector('[id*="__navbar"].sticky-top')?.clientHeight || 0
            const announcementBarHeight = document.querySelector('[id*="__announcement-bar"].sticky-top')?.clientHeight || 0
            gallery.style.position = 'sticky'
            gallery.style.top = `${navbarHeight + announcementBarHeight + 20}px`
            gallery.style.zIndex = '1'
        }

        if (window.GLightbox) {
            // eslint-disable-next-line no-unused-vars
            const lightbox = GLightbox({
                selector: `[data-gallery="product-gallery-${gallery.dataset.productId}"]`,
                videosWidth: '1290px',
                loop: true
            })
            lightbox.on('slide_changed', ({ prev, current }) => {
                main.go(current.index)
            })
        }

        const modelViewer = gallery.querySelector('model-viewer')

        if (modelViewer) {
            const increaseBtn = gallery.querySelector('[data-model-3d-increase-zoom]')
            const decreaseBtn = gallery.querySelector('[data-model-3d-decrease-zoom]')
            const fullscreenBtn = gallery.querySelector('[data-model-3d-fullscreen]')

            increaseBtn.addEventListener('click', () => {
                modelViewer.zoom(1)
            })

            decreaseBtn.addEventListener('click', () => {
                modelViewer.zoom(-1)
            })

            fullscreenBtn.addEventListener('click', () => {
                if (document.fullscreenElement) {
                    document.exitFullscreen()
                    fullscreenBtn.querySelector('.bi-fullscreen').removeAttribute('hidden')
                    fullscreenBtn.querySelector('.bi-fullscreen-exit').setAttribute('hidden', 'hidden')
                } else {
                    modelViewer.closest('.product-gallery-model-3d').requestFullscreen()
                    fullscreenBtn.querySelector('.bi-fullscreen').setAttribute('hidden', 'hidden')
                    fullscreenBtn.querySelector('.bi-fullscreen-exit').removeAttribute('hidden')
                }
            })
        }
    })
}
initProductGallery()

document.addEventListener('shopify:section:load', (e) => {
    if (e.target.querySelector('.product-gallery')) {
        initProductGallery()
    }
})

window.addEventListener('updated.ecomify.collection', initProductGallery)

/*
    Inventory Bar
*/
const initInventoryBar = () => {
    const wrapper = document.querySelector('#inventory-bar')

    if (!wrapper) return

    const progressBar = wrapper.querySelector('.progress-bar')

    setTimeout(() => {
        progressBar.style.width = progressBar.dataset.width
    }, 250)
}
initInventoryBar()

document.addEventListener('shopify:section:load', (e) => {
    if (e.target.querySelector('#inventory-bar')) {
        initInventoryBar()
    }
})

/*
    Upsell modal
*/
const initUpsellModal = () => {
    const modal = document.querySelector('#product-upsell-modal')
    if (!modal) return

    const form = document.querySelector('#product-content form[onsubmit*="onSubmitAtcForm"]')
    if (!form) return

    form.setAttribute('data-ecomify-upsell-modal', 'true')

    form.addEventListener('submit', (e) => {
        const modal = bootstrap.Modal.getOrCreateInstance('#product-upsell-modal')
        modal.show()
    })

    document.querySelectorAll('#product-upsell-modal .btn-atc').forEach(btn => {
        btn.addEventListener('click', () => {
            const footerBtn = document.querySelector('#product-upsell-modal .modal-footer .btn')
            footerBtn.classList.remove(footerBtn.dataset.defaultClass)
            footerBtn.classList.add(footerBtn.dataset.activeClass)
        })
    })

    modal.addEventListener('hidden.bs.modal', () => {
        const offcanvasCart = bootstrap.Offcanvas.getOrCreateInstance('#offcanvas-cart')
        offcanvasCart.show()
    })
}
initUpsellModal()

document.addEventListener('shopify:section:load', (e) => {
    if (e.target.querySelector('#product-upsell-modal')) {
        initUpsellModal()
    }
})

/*
    Bought Together
*/
const initBoughtTogether = () => {
    if (!document.querySelector('#product-bought-together')) return

    const setTotalPrice = () => {
        let totalCompareAtPrice = 0
        let totalPrice = 0

        document.querySelectorAll('#product-bought-together .product-item-price').forEach(elem => {
            if (elem.closest('.product-item').querySelector('.bought-together-check:checked')) {
                totalCompareAtPrice += elem.dataset.compareAtPrice.length ? Number(elem.dataset.compareAtPrice) : Number(elem.dataset.price)
                totalPrice += Number(elem.dataset.price)
            }
        })

        const totalElem = document.querySelector('#bought-together-total')

        if (totalCompareAtPrice > totalPrice) {
            totalElem.innerHTML = `
                ${totalElem.dataset.textTotalPrice}: 
                <span class="bought-together-total-compare-price text-muted me-2">
                    <span class="visually-hidden">
                        ${window.theme.product.priceFrom} &nbsp;
                    </span>
                    <s>
                        ${Shopify.formatMoney(totalCompareAtPrice)}
                    </s>
                </span>
                <span class="bought-together-total-price text-success">
                    <span class="visually-hidden">
                        ${window.theme.product.priceSale} &nbsp;
                    </span>
                    ${Shopify.formatMoney(totalPrice)}
                </span>
            `
        } else {
            totalElem.innerHTML = `
                ${totalElem.dataset.textTotalPrice}: 
                <span class="bought-together-total-price">
                    ${Shopify.formatMoney(totalPrice)}
                </span>
            `
        }
    }

    document.querySelectorAll('.bought-together-check').forEach((checkbox) => {
        checkbox.addEventListener('change', () => {
            if (checkbox.checked) {
                checkbox.closest('.product-item').style.opacity = '1'
            } else {
                checkbox.closest('.product-item').style.opacity = '.5'
            }

            if (document.querySelector('.bought-together-check:checked')) {
                document.querySelector('#bought-together-atc').disabled = false
            } else {
                document.querySelector('#bought-together-atc').disabled = true
            }

            setTotalPrice()
        })
    })

    document.querySelectorAll('#product-bought-together select[name="id"]').forEach(select => {
        select.addEventListener('change', () => {
            const compareAtPrice = select.options[select.selectedIndex].dataset.compareAtPrice
            const price = select.options[select.selectedIndex].dataset.price

            select.closest('.product-item').querySelector('.product-item-price')
                .setAttribute('data-compare-at-price', compareAtPrice)
            select.closest('.product-item').querySelector('.product-item-price')
                .setAttribute('data-price', price)

            setTotalPrice()
        })
    })

    document.querySelector('#bought-together-atc').addEventListener('click', async (e) => {
        const btn = e.target

        btn.style.width = btn.clientWidth + 4 + 'px'
        btn.innerHTML = `
            <div class="spinner-border spinner-border-sm" role="status">
                <span class="visually-hidden">Loading...</span>
            </div>
        `

        const items = []

        document.querySelectorAll('#product-bought-together .product-item').forEach(elem => {
            if (elem.querySelector('.bought-together-check:checked')) {
                items.push({
                    id: Number(elem.querySelector('[name="id"]').value),
                    quantity: 1
                })
            }
        })

        const response = await fetch('/cart/add.js', {
            method: 'POST',
            headers: { 'Content-Type': 'application/json' },
            body: JSON.stringify({ items })
        })

        btn.innerHTML = window.theme.product.addedToCart

        setTimeout(() => {
            btn.innerHTML = btn.dataset.textAddToCart
        }, 2000)

        window.refreshCartContents(response)

        bootstrap.Offcanvas.getOrCreateInstance('#offcanvas-cart').show()
    })
}
initBoughtTogether()

/*
    Qty Breaks
*/
const initQtyBreaks = () => {
    document.querySelectorAll('[name="product-qty-breaks"]').forEach(radio => {
        radio.addEventListener('change', () => {
            const qty = Number(radio.dataset.qty)

            const qtyField = radio.closest('form').querySelector('[name="quantity"]')
            const btn = radio.closest('form').querySelector('button[name="add"]')

            if (!qtyField) return

            qtyField.value = qty

            setTimeout(() => {
                btn.classList.add('animate__animated', 'animate__shakeX')
            }, 250)

            setTimeout(() => {
                btn.classList.remove('animate__animated', 'animate__shakeX')
            }, 1500)
        })
    })
}
initQtyBreaks()

/*
    Prev/Next Products (will show only if the product is within a collection)
*/
const initPrevNextButtons = async () => {
    const wrapper = document.querySelector('#product-prev-next')

    if (!wrapper) return

    if (!window.matchMedia('(max-width: 1599px)').matches) return

    await new Promise(resolve => setTimeout(resolve, 1000))

    const threshold = document.querySelector('.product-content .form-wrapper').getBoundingClientRect().bottom + window.scrollY

    window.addEventListener('scroll', () => {
        if (window.scrollY > threshold) {
            wrapper.classList.add('show')
        } else {
            wrapper.classList.remove('show')
        }
    })
}
initPrevNextButtons()

/*
    Gift Personalization
*/
const initGiftPersonalization = () => {
    const noteCollapse = document.querySelector('#gift-personalization-note-collapse')

    if (!noteCollapse) {
        return
    }

    const noteCollapseBtn = document.querySelector('#gift-personalization-note-collapse-btn')

    noteCollapse.addEventListener('show.bs.collapse', event => {
        noteCollapseBtn.querySelector('.form-check-input').checked = true
    })

    noteCollapse.addEventListener('hide.bs.collapse', event => {
        noteCollapseBtn.querySelector('.form-check-input').checked = false
    })
}
initGiftPersonalization()

/*
    Limited Offer
*/
const initLimitedOffer = () => {
    const block = document.querySelector('#product-limited-offer')

    if (!block) return

    const icon = block.querySelector('.block-icon')

    setInterval(() => {
        icon.classList.add('animate__animated', 'animate__tada')

        setTimeout(() => {
            icon.classList.remove('animate__animated', 'animate__tada')
        }, 1500)
    }, 3000)
}
initLimitedOffer()

/*
    Delivery Info
*/
document.querySelectorAll('.product-delivery-info').forEach(elem => {
    const firstSpan = elem.querySelector('.description span:first-child')
    const secondSpan = elem.querySelector('.description span:last-child')
  if(firstSpan){
    firstSpan.textContent = dayjs().add(Number(firstSpan.textContent.replace('days', '')), 'day').format('MMM DD')
  }
  if(secondSpan){
    secondSpan.textContent = dayjs().add(Number(secondSpan.textContent.replace('days', '')), 'day').format('MMM DD')
  }
})

/*
  Quick view - read more description
*/
const initQuickViewReadMore = () => {
    document.querySelectorAll('.quick-view-product-description').forEach(elem => {
        elem.querySelectorAll('p').forEach((p, index) => {
            if (index === 0) {
                p.style.textOverflow = 'ellipsis'
                p.insertAdjacentHTML('beforeend', `
                    <a 
                        href="javascript:void(0)" 
                        class="view-more-toggle-btn"
                        role="button">
                        Read all...
                    </a>
                `)
                p.querySelector('.view-more-toggle-btn').addEventListener('click', () => {
                    elem.querySelectorAll('p').forEach(p => {
                        p.style.display = 'block'
                    })
                    p.querySelector('.view-more-toggle-btn').remove()
                })
            } else {
                p.style.display = 'none'
            }
        })
    })

    // const descriptionDivs = document.querySelectorAll(".quick-view-product-description");
    // const toggleButtons = document.querySelectorAll(".view-more-toggle-btn");

    // descriptionDivs.forEach((div, index) => {
    //     let isCollapsed = true;
    //     const paragraphs = div.querySelectorAll('p');  // Find all <p> tags inside the div

    //     // Initialize by hiding all paragraphs except the first one.
    //     paragraphs.forEach((p, pIndex) => {
    //         if (pIndex === 0) {
    //             // p.classList.add('text-truncate');
    //             p.style.overflow = 'hidden';
    //             // p.style.whiteSpace = 'nowrap';
    //             p.style.textOverflow = 'ellipsis';
    //         } else {
    //             p.style.display = 'none';
    //         }
    //     });

    //     toggleButtons[index].addEventListener("click", function() {
    //         if (isCollapsed) {
    //             // Show all paragraphs and remove truncation from the first one
    //             paragraphs.forEach(p => {
    //                 p.style.display = 'block';
    //                 // p.classList.remove('text-truncate');
    //                 p.style.overflow = 'visible';
    //                 p.style.whiteSpace = 'normal';
    //                 p.style.textOverflow = 'clip';
    //             });
    //             this.innerText = "Read Less";
    //         } else {
    //             // Hide all paragraphs except the first one and truncate it
    //             paragraphs.forEach((p, pIndex) => {
    //                 if (pIndex === 0) {
    //                     // p.classList.add('text-truncate');
    //                     p.style.overflow = 'hidden';
    //                     // p.style.whiteSpace = 'nowrap';
    //                     p.style.textOverflow = 'ellipsis';
    //                 } else {
    //                     p.style.display = 'none';
    //                 }
    //             });
    //             this.innerText = "Read More";
    //         }
    //         isCollapsed = !isCollapsed;
    //     });
    // });
}
initQuickViewReadMore()

// Gift box toggler
document.querySelectorAll('button.btn-toggler-gift-box').forEach(btn => {
    btn.addEventListener('click', (event) => {
        event.preventDefault()

        if (btn.classList.contains('active')) {
            btn.classList.remove('active')
            btn.innerHTML = 'Add A Gift Box'

            // btn.closest('.modal-body').querySelector('[data-price-elem-without-gift-box]').removeAttribute('hidden')
            // btn.closest('.modal-body').querySelector('[data-price-elem-with-gift-box]').setAttribute('hidden', 'hidden')

            btn.closest('form').querySelector('[name="id"]').setAttribute('value', btn.dataset.withoutGiftBoxVariantId);
            let priceElement = btn.closest('form').parentNode.nextElementSibling;
            let currencyValue = (parseInt(btn.dataset.withoutGiftBoxPrice, 10) / 100).toLocaleString('en-US', { style: 'currency', currency: 'USD' });
            console.log(priceElement);
            console.log(currencyValue);
            priceElement.innerHTML = `${priceElement.innerText.split('|')[0].trim()} | ${currencyValue}`;   
        } else {
            btn.classList.add('active');
            btn.innerHTML = 'Gift Box Included';

            // btn.closest('.modal-body').querySelector('[data-price-elem-without-gift-box]').setAttribute('hidden', 'hidden')
            // btn.closest('.modal-body').querySelector('[data-price-elem-with-gift-box]').removeAttribute('hidden')

            btn.closest('form').querySelector('[name="id"]').setAttribute('value', btn.dataset.withGiftBoxVariantId);
            let priceElement = btn.closest('form').parentNode.nextElementSibling;
            let currencyValue = (parseInt(btn.dataset.withGiftBoxPrice, 10) / 100).toLocaleString('en-US', { style: 'currency', currency: 'USD' });
            console.log(priceElement);
            console.log(currencyValue);
            priceElement.innerHTML = `${priceElement.innerText.split('|')[0].trim()} | ${currencyValue}`;   
        }
    })
})

